/**
 * deviceHelper.js - 設備偵測工具
 * 用於檢測用戶設備類型（桌面、平板、手機）
 */

/**
 * 檢測是否為平板設備
 * @returns {boolean} 若為平板返回 true
 */
export function isTablet() {
  const userAgent = navigator.userAgent.toLowerCase();
  
  // iPad（含舊版 iPadOS 12 以前）
  if (/ipad/.test(userAgent)) {
    return true;
  }
  
  // iPadOS 13+ 將 UA 偽裝成 macOS，需用 maxTouchPoints 區分
  if (/macintosh/.test(userAgent) && navigator.maxTouchPoints > 1) {
    return true;
  }
  
  // Android 平板
  if (/android/.test(userAgent)) {
    // 檢查螢幕寬度作為輔助判斷
    // 一般平板寬度 >= 600px
    if (window.innerWidth >= 600) {
      return true;
    }
    // 某些 Android 平板在 UA 中包含 "tablet"
    if (/tablet/.test(userAgent)) {
      return true;
    }
  }
  
  // Windows 平板（如 Surface）
  if (/windows nt/.test(userAgent) && window.innerWidth < 1024 && window.innerHeight >= 600) {
    // Surface-like device with touch capability
    if (navigator.maxTouchPoints && navigator.maxTouchPoints > 1) {
      return true;
    }
  }
  
  return false;
}

/**
 * 檢測是否為手機設備
 * @returns {boolean} 若為手機返回 true
 */
export function isMobile() {
  const userAgent = navigator.userAgent.toLowerCase();
  
  // 基本手機判斷
  if (/mobile|phone|android|iphone|ipod|blackberry|windows phone/.test(userAgent)) {
    // 排除平板
    if (!isTablet()) {
      return true;
    }
  }
  
  return false;
}

/**
 * 檢測是否為桌面設備
 * @returns {boolean} 若為桌面返回 true
 */
export function isDesktop() {
  return !isTablet() && !isMobile();
}

/**
 * 獲取設備類型
 * @returns {string} 返回 'tablet', 'mobile', 或 'desktop'
 */
export function getDeviceType() {
  if (isTablet()) {
    return 'tablet';
  }
  if (isMobile()) {
    return 'mobile';
  }
  return 'desktop';
}

/**
 * 檢測是否支持觸屏
 * @returns {boolean}
 */
export function isTouchSupported() {
  return (
    ('ontouchstart' in window) ||
    (navigator.maxTouchPoints && navigator.maxTouchPoints > 0) ||
    (navigator.msMaxTouchPoints && navigator.msMaxTouchPoints > 0)
  );
}
